import React from 'react'
import { connect } from 'react-redux'
import { openAllotmentResultEnquiry, openApplyDialog, openMarginApplyDialog, openIpoCancelDialog} from '@/actions/app';
import { getInitState, getSafe } from '../../../helpers/global';
import {ipoCancel} from '../../../configurations/app-configs/app.setting.config'
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';
import { keyDownFunctions, accessibilityFunctions } from '@/helpers/functions';

const ENQUIRE = 'E';
const APPLY = 'A';
const MARGIN = 'M';
const MARGIN_APPLY = 'MA';
const CANCEL = 'C';
const MODIFY = 'MO';

const initStateFunc = getInitState({
  TTLGetActions(data) {
    let actions = []
    const disableCancel = iTradeEnv?.pages?.ipo?.margin?.disableCancel ?? false;
    if (data.applied === 'Y') {
      if(data.remainDays > 0 || data.remainHours > 0){
        if(data.enableMargin === 'Y'){
          if(ipoCancel){
            actions = ['E','MO','C'];
          }else{
            actions = ['E','MO'];
          }
        }else{
          actions = ['E','MO','C'];
        }
        if(data.status === 'W'){
          actions = ['E','MO'];
        }
        if(disableCancel && (data.marginFinancingType === 'O' || data.marginFinancingType === 'E')){
          actions = ['E','MO'];
          // actions = ['E','MO','C'];
        }
      }else{
        actions = ['E'];
      }
    } else if (data.status === 'O') {
      actions = ['A'];
      if (data.enableMargin === 'Y') {
        actions = ['A', 'MA'];
      }
    }
    return actions;
  },
  SCBGetActions(data) {
    let actions = []
    const disableCancel = iTradeEnv?.pages?.ipo?.margin?.disableCancel ?? false;
    if (data.applied === 'Y') {
      if(data.remainDays > 0 || data.remainHours > 0){
        if(data.enableMargin === 'Y'){
          if(ipoCancel){
            actions = ['E','MO','C'];
          }else{
            actions = ['E','MO'];
          }
        }else{
          actions = ['E','MO','C'];
        }
        if(data.status === 'W'){
          actions = ['E','MO'];
        }
        if(disableCancel && (data.marginFinancingType === 'O' || data.marginFinancingType === 'E')){
          actions = ['E','MO'];
          // actions = ['E','MO','C'];
        }
      }else{
        actions = ['E'];
      }
    } else if (data.status === 'O') {
      actions = ['A'];
      if (data.enableMargin === 'Y') {
        actions = ['A', 'MA'];
      }
    }
    return actions;
  },
  EIFGetActions(data) {
    let actions = []
    const disableCancel = iTradeEnv?.pages?.ipo?.margin?.disableCancel ?? false;
    if (data.applied === 'Y') {
      if(data.remainDays > 0 || data.remainHours > 0){
        if(data.enableMargin === 'Y'){
          if(ipoCancel){
            actions = ['E','MO','C'];
          }else{
            actions = ['E','MO'];
          }
        }else{
          actions = ['E','MO','C'];
        }
        if(data.status === 'W'){
          actions = ['E','MO'];
        }
        if(disableCancel && (data.marginFinancingType === 'O' || data.marginFinancingType === 'E')){
          actions = ['E','MO'];
          // actions = ['E','MO','C'];
        }
      }else{
        actions = ['E'];
      }
    } else if (data.status === 'O') {
      actions = ['A'];
      if (data.enableMargin === 'Y') {
        actions = ['A', 'MA'];
      }
    }
    return actions;
  },
  CMBIGetActions(data) {
    let actions = []
    const disableCancel = iTradeEnv?.pages?.ipo?.margin?.disableCancel ?? false;
    if (data.applied === 'Y') {
      if(data.remainDays > 0 || data.remainHours > 0){
        if(data.enableMargin === 'Y'){
          if(ipoCancel){
            actions = ['E','MO','C'];
          }else{
            actions = ['E','MO'];
          }
        }else{
          actions = ['E','MO','C'];
        }
        if(data.status === 'W'){
          actions = ['E','MO'];
        }
        if(disableCancel && (data.marginFinancingType === 'O' || data.marginFinancingType === 'E')){
          actions = ['E','MO'];
          // actions = ['E','MO','C'];
        }
      }else{
        actions = ['E'];
      }
    } else if (data.status === 'O') {
      actions = ['A'];
      if (data.enableMargin === 'Y') {
        actions = ['A', 'MA'];
      }
    }
    return actions;
  },
  BASICGetActions(data) {
    let actions = []
    const disableCancel = iTradeEnv?.pages?.ipo?.margin?.disableCancel ?? false;
    if (data.applied === 'Y') {
      if(data.remainDays > 0 || data.remainHours > 0){
        if(data.enableMargin === 'Y'){
          if(ipoCancel){
            actions = ['E','MO','C'];
          }else{
            actions = ['E','MO'];
          }
        }else{
          actions = ['E','MO','C'];
        }
        if(data.status === 'W'){
          actions = ['E','MO'];
        }
        if(disableCancel && (data.marginFinancingType === 'O' || data.marginFinancingType === 'E')){
          actions = ['E','MO'];
          // actions = ['E','MO','C'];
        }
      }else{
        actions = ['E'];
      }
    } else if (data.status === 'O') {
      actions = ['A'];
      if (data.enableMargin === 'Y') {
        actions = ['A'];
      }
    }
    return actions;
  },
  FUBONGetActions(data) {
    let actions = []
    const disableCancel = iTradeEnv?.pages?.ipo?.margin?.disableCancel ?? false;
    if (data.applied === 'Y') {
      if(data.remainDays > 0 || data.remainHours > 0){
        if(data.enableMargin === 'Y'){
          if(ipoCancel){
            actions = ['E','MO','C'];
          }else{
            actions = ['E','MO'];
          }
        }else{
          actions = ['E','MO','C'];
        }
        if(data.status === 'W'){
          actions = ['E','MO'];
        }
        if(disableCancel && (data.marginFinancingType === 'O' || data.marginFinancingType === 'E')){
          actions = ['E','MO'];
          // actions = ['E','MO','C'];
        }
      }else{
        actions = ['E'];
      }
    } else if (data.status === 'O') {
      actions = ['A'];
      if (data.enableMargin === 'Y') {
        actions = ['A', 'MA'];
      }
    }
    return actions;
  },
})

class IPOCellRender extends React.Component {
  render() {
    return this.renderContent()
  }

  getActions() {
    const { data } = this.props;
    return initStateFunc('TTLGetActions', data)
  }

  renderAction() {
    const actions = this.getActions();
    return (<div className="item-fl-action-row" style={{ padding: 0 }}>
      {actions.map(act =>
        <span key={act} className="ipo-action-item" 
              onClick={() => this.handleIPOActions(act)} 
              {...accessibilityFunctions.hasTabIndex()}
              onKeyDown={keyDownFunctions.handleEnterKeyDown(() =>  this.handleIPOActions(act))}
        >
          {this.handleGetIPActionTitle(act)}
        </span>
      )}
    </div>)
  }


  handleGetIPActionTitle(action) {
    const { language } = this.props;
    switch (action) {
      case APPLY: return language.ipo_apply;
      case MARGIN: return language.common_margin;
      case MARGIN_APPLY: return `${language.ipo_margin_apply}`;
      case ENQUIRE: return language.ipo_enquire;
      case CANCEL: return language.ipo_cancel;
      case MODIFY: return language.ipo_modify;
      default: return '';
    }
  }

  handleIPOActions(action) {
    const { data } = this.props;

    switch (action) {
      case APPLY:
        openApplyDialog(data, 'A');
        break;
      // case MARGIN:
      //   break;
      case MARGIN_APPLY:
        openApplyDialog(data, 'MA');
        break;
      case ENQUIRE:
        openAllotmentResultEnquiry(data);
        break;
      case CANCEL:
        openIpoCancelDialog(data);
        break;
      case MODIFY:
        openApplyDialog(data, 'MO');
      default: break;
    }
  }

  renderTimeRemain() {
    const { data, language } = this.props;
    const timeRemain = {
      quantity: language.common_expired,
      unit: ''
    }
    if (data.remainDays > 0) {
      timeRemain.quantity = data.remainDays;
      timeRemain.unit = `${language.common_day}${language.lang === 'en_US' ? 's' : ''}`;
    } else if (data.remainHours > 0) {
      timeRemain.quantity = data.remainHours;
      timeRemain.unit = `${language.common_hour}${language.lang === 'en_US' && data.remainHours > 1 ? 's' : ''}`;
    }
    return (
      <div className="ipo-time-remaining">
        <span className='quantity'>{timeRemain.quantity}</span>
        {timeRemain.unit && <span className='unit'>{timeRemain.unit}</span>}
      </div>
    )
  }

  renderStatus() {
    const { data, language } = this.props;
    let keyLanguage = '';
    switch (data.status) {
      case 'O': keyLanguage = 'ipo_status_open'; break;
      case 'F': keyLanguage = 'ipo_status_confirmed'; break;
      case 'D': keyLanguage = 'ipo_status_confirmed'; break;
      case 'C': keyLanguage = 'ipo_status_closed'; break;
      case 'H': keyLanguage = 'ipo_status_accepted'; break;
      case 'I': keyLanguage = 'ipo_status_accepted'; break;
      case 'W': keyLanguage = 'ipo_status_accepted'; break;
      case 'X': keyLanguage = 'ipo_status_cancelled'; break;
      default: break;
    }
    return (
      <div>
        <span>{getSafe(() => language[keyLanguage], keyLanguage)}</span>
      </div>
    )
  }

  renderContent() {
    const { colDef } = this.props;
    switch (colDef.colId) {
      case 'common_actions': return this.renderAction();
      case 'ipo_time_remaining': return this.renderTimeRemain();
      case 'common_status': return this.renderStatus();
      case 'ipo_status': return this.renderStatus();
      default: break;
    }
  }
}

export default connect(
  state => ({
    language: state.app.language
  })
)(IPOCellRender)
